module.exports = __webpack_public_path__ + "img/icon_menu_notice_2.a44e3fe2.svg";